import React from 'react';
import type { ThreadMessage } from '../../utils/conversation';
import { formatTime } from '../../utils/timeline';
interface MessageBubbleProps {
  message: ThreadMessage;
  focused: boolean;
  contactFirstName: string;
}
export function MessageBubble({
  message,
  focused,
  contactFirstName
}: MessageBubbleProps) {
  const outbound = message.from === 'you';
  return <div className={`flex flex-col ${outbound ? 'items-end' : 'items-start'}`} data-id="element-50" data-mp="ey095138lyhr">
      <p className={`max-w-[86%] rounded-lg px-3 py-2 text-[13px] leading-relaxed transition-shadow duration-200 ease-emphasis ${outbound ? 'bg-accent text-white' : 'bg-surface text-ink ring-1 ring-line'} ${focused ? 'ring-2 ring-gold ring-offset-2 ring-offset-surface-muted' : ''}`} data-id="element-51" data-mp="evw8cs0mxflp">
        {message.body}
      </p>

      <span className="mt-1 flex flex-wrap items-center gap-x-1.5 gap-y-1 text-[11px] text-ink-subtle" data-id="element-52" data-mp="xmezdm5qd8hi">
        <span data-id="element-53" data-mp="12li22zy8n2mb">
          {outbound ? 'You' : contactFirstName} · {formatTime(message.at)}
        </span>
        {focused && <span className="rounded bg-gold-soft px-1.5 py-0.5 font-display text-[10px] font-bold uppercase tracking-[0.08em] text-gold-ink" data-id="element-54" data-mp="wmoqz1a3wnx3">
            Selected
          </span>}
      </span>
    </div>;
}